import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlogComponent } from './blog.component';

const routes: Routes = [
  {
    path: 'blog',
    redirectTo: '/blog/welcome-to-adventure-forge',
    pathMatch: 'full',
  },
  {
    path: 'blog',
    component: BlogComponent,
    children: [
      {
        path: 'main',
        loadChildren: () =>
          import('./main/main.module').then((m) => m.MainModule),
      },
      {
        path: 'welcome-to-adventure-forge',
        loadChildren: () =>
          import(
            './welcome-to-adventure-forge/welcome-to-adventure-forge.module'
          ).then((m) => m.WelcomeToAdventureForgeModule),
      },
      {
        path: 'tales-of-fortunata-reveal',
        loadChildren: () =>
          import(
            './tales-of-fortunata-reveal/tales-of-fortunata-reveal.module'
          ).then((m) => m.TalesOfFortunataRevealModule),
      },
      {
        path: 'md-article',
        loadChildren: () =>
          import('./md-article/md-article.module').then(
            (m) => m.MdArticleModule,
          ),
      },
      {
        path: ':id',
        loadChildren: () =>
          import('./article/article.module').then((m) => m.ArticleModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BlogRoutingModule {}
